import { render, staticRenderFns } from "./goDashboardPreview.vue?vue&type=template&id=3aa69a99&scoped=true"
import script from "./goDashboardPreview.vue?vue&type=script&lang=js"
export * from "./goDashboardPreview.vue?vue&type=script&lang=js"
import style0 from "./goDashboardPreview.vue?vue&type=style&index=0&id=3aa69a99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa69a99",
  null
  
)

export default component.exports